var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "color",
    d: "M153.56,455c-25.43,0-49.44-10.07-67.96-28.6c-19.4-19.4-29.53-44.81-28.53-71.57 c1.03-27.63,13.51-54.17,36.1-76.75l40.66-40.83c6.06-6.08,15.9-6.1,21.99-0.05c6.08,6.06,6.1,15.9,0.05,21.99l-40.68,40.85 c-32.97,32.97-36.08,75.88-7.59,104.37c28.49,28.49,71.4,25.38,104.34-7.57l55.88-55.88c16.94-16.94,26.28-36.28,27.01-55.93 c0.67-18.01-6.23-35.21-19.45-48.42c-4.43-4.43-9.33-8.18-14.56-11.16c-7.46-4.25-10.06-13.74-5.81-21.2 c4.25-7.46,13.74-10.06,21.2-5.81c7.65,4.36,14.77,9.81,21.16,16.2c19.4,19.4,29.53,44.81,28.53,71.56 c-1.03,27.63-13.51,54.17-36.1,76.75l-55.88,55.88c-22.58,22.58-49.12,35.06-76.75,36.1C155.96,454.98,154.76,455,153.56,455z  M257,307.74c4.25-7.46,1.65-16.95-5.81-21.2c-5.23-2.98-10.13-6.74-14.56-11.16c-28.49-28.49-25.38-71.4,7.57-104.35l55.88-55.88 c32.95-32.94,75.85-36.06,104.34-7.57c28.49,28.49,25.38,71.4-7.59,104.37l-40.68,40.85c-6.06,6.08-6.04,15.93,0.05,21.99 c6.08,6.06,15.93,6.04,21.99-0.05l40.66-40.83c22.58-22.58,35.06-49.12,36.1-76.75c1-26.75-9.13-52.17-28.53-71.57 c-19.4-19.4-44.83-29.53-71.57-28.53c-27.63,1.03-54.17,13.51-76.75,36.1l-55.88,55.88c-22.58,22.58-35.06,49.12-36.1,76.75 c-1,26.75,9.13,52.17,28.53,71.57c6.39,6.39,13.51,11.84,21.16,16.2c2.43,1.38,5.07,2.04,7.68,2.04 C248.88,315.6,254.13,312.77,257,307.74z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLink);
export default __webpack_public_path__ + "static/media/small-link.9561540c988a2866abc4e7329c38bdd6.svg";
export { ForwardRef as ReactComponent };